//  * 多选组件
//  * @author hj <5263954@qq.com>
//  * @date 2018-03-07
//  * @since 1.0.0

import Vue from 'src/views/base'
import { Component, Prop, Watch } from 'vue-property-decorator'
import template from './goback.vue'

@Component({
    name: 'goback',
    mixins: [template],
    components: {
    }
})
export default class Goback extends Vue {
    isAndroid = false

    goback() {
        this.$router.go(-1)
    }

    created () {
        var agent = navigator.userAgent.toLowerCase()
        this.isAndroid = agent.indexOf('android') > -1 || agent.indexOf('adr') > -1 // android终端
    }
}




// WEBPACK FOOTER //
// ./src/views/page/ems/unit/goback/index.js